import React from "react";
import staff from "../../assets/image.png";
import staff1 from "../../assets/image4.png";
import staff2 from "../../assets/image5.png";
import staff3 from "../../assets/image6.png";
import Footer from "../footer";
import {
  DivisionDescription,
  DivisionImage,
  InfoCompanyDivisionContainer,
  InfoCompanyDivisionContent,
} from "../../styles/InfoCompanyDivision";
import { Typography } from "@mui/material";
import { StaffHeader } from "../../styles/staff";
import AppDrawer from "../drawer";
import Cart from "../cart";
import Checkout from "../checkout";
import SearchBox from "../search";

const Staff = () => {
  return (
    <>
      <StaffHeader>Our Staff</StaffHeader>
      <>
        <InfoCompanyDivisionContainer>
          <InfoCompanyDivisionContent>
            <DivisionImage src={staff} />
            <DivisionDescription>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Dr. Olivia Roberts
              </Typography>
              <Typography>
                Dr. Olivia Roberts is a renowned cardiologist with a focus on
                preventive cardiology.
              </Typography>
            </DivisionDescription>
          </InfoCompanyDivisionContent>

          <InfoCompanyDivisionContent>
            <DivisionImage src={staff1} />
            <DivisionDescription>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Dr. Benjamin Miller
              </Typography>
              <Typography>
                Dr. Benjamin Miller is an experienced orthopedic surgeon
                specializing in sports medicine.
              </Typography>
            </DivisionDescription>
          </InfoCompanyDivisionContent>

          <InfoCompanyDivisionContent>
            <DivisionImage src={staff3} />
            <DivisionDescription>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Dr. Ethan Wilson
              </Typography>
              <Typography>
                Dr. Ethan Wilson is a respected neurosurgeon specializing in
                complex brain and spinal surgeries.
              </Typography>
            </DivisionDescription>
          </InfoCompanyDivisionContent>

          <InfoCompanyDivisionContent>
            <DivisionImage src={staff2} />
            <DivisionDescription>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Dr. Lucas Anderson
              </Typography>
              <Typography>
                Dr. Lucas Anderson is a compassionate family physician who
                emphasizes a holistic approach to healthcare.
              </Typography>
            </DivisionDescription>
          </InfoCompanyDivisionContent>
        </InfoCompanyDivisionContainer>
      </>
      <Footer />
      <AppDrawer />
      <Cart />
      <Checkout />
      <SearchBox />
    </>
  );
};

export default Staff;
